import React from "react";
import {
  LineChart,
  Line,
  YAxis,
  ResponsiveContainer,
  Area,
  AreaChart,
  Tooltip,
  XAxis,
} from "recharts";

// Custom Tooltip Component
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const { attempt, score, targetscore } = payload[0].payload;
    return (
      <div
        style={{
          backgroundColor: "white",
          padding: "4px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          boxShadow: "2px 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <p style={{ margin: "0 0 10px 0" }}>Attempt: {attempt}</p>
        <p style={{ margin: "0" }}>
          Score: {score}/{targetscore}
        </p>
      </div>
    );
  }
  return null;
};

const GraphForAttempts = ({ attemptedData, page = "mocktestpage"}) => {
  return (
    <ResponsiveContainer height={140}>
      <AreaChart
        data={attemptedData}
        margin={{ top: 50, right: 10, left: 10, bottom: 20 }}
      >
        <defs>
          <linearGradient id="colorBlue" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#A9B2F3" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#A9B2F3" stopOpacity={0} />
          </linearGradient>
        </defs>

        {page === "ccpage" && (
          <>
            {/* Top X-Axis - Shows Attempt number and Score */}
            <XAxis
              xAxisId="top"
              dataKey="attempt"
              orientation="top"
              interval={0}
              axisLine={false}
              tickLine={false}
              tick={({ x, y, payload }) => {
                const item = attemptedData[payload.index];
                return (
                  <g transform={`translate(${x},${y})`}>
                    <text
                      x={0}
                      y={0}
                      dy={-15}
                      textAnchor="middle"
                      fill="#888"
                      fontSize={11}
                    >
                      Attempt {item.attempt}
                    </text>
                    <text
                      x={0}
                      y={0}
                      dy={0}
                      textAnchor="middle"
                      fill="#000"
                      fontSize={13}
                      fontWeight="bold"
                    >
                      {item.score}/{item.targetscore}
                    </text>
                  </g>
                );
              }}
            />

            {/* Bottom X-Axis - Hidden, just for positioning */}
            <XAxis xAxisId="bottom" dataKey="attempt" hide />
          </>
        )}
        {/* Y-Axis */}
        <YAxis domain={[0, 10]} hide />

        {/* Tooltip on Hover */}
        <Tooltip
          content={<CustomTooltip />}
          cursor={{ stroke: "transparent" }}
        />

        {/* Area Graph */}
        <Area
          xAxisId="bottom"
          type="monotone"
          dataKey="score"
          stroke="#4285F4"
          strokeWidth={2}
          fill="url(#colorBlue)"
        />
        <Line
          xAxisId="bottom"
          type="monotone"
          dataKey="score"
          stroke="#4285F4"
          strokeWidth={2}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default GraphForAttempts;
